import { createFileRoute } from '@tanstack/react-router';

import Page from '@/screens/settings/page';

export const Route = createFileRoute('/_app/settings/')({
  component: Page,
});
